/* eslint-disable */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'
import VideoPlayer from '../events/Video'

const VideoTab = () => {
  const { lang } = useTranslation('client')

  return (
    <Container size="sm">
      <Paper>
        <div>
          <VideoPlayer
            data={[
              {
                url: 'https://www.youtube.com/watch?v=oN_ejrQRw9s',
                media: 'youtube',
                title:
                  lang === 'en'
                    ? 'A guide students on how to purchase the service and use the technologies of Infinity Medical Academy'
                    : 'Infinity Medical Academy دليل للطلاب حول كيفية شراء الخدمة واستخدام تقنيات',
              },
            ]}
          />
        </div>
      </Paper>
    </Container>
  )
}

export default VideoTab
